import * as React from 'react';
import * as styles from './NumChildren.css';
import Render from '../../../../Shared/Render';

export function NumChildren({ numChildren }: { numChildren: number }) {
	return (
		<Render
			id="numberOfChildren"
			when={numChildren !== 0}
			withClasses={styles.numChildren}
		>
			{numChildren}
		</Render>
	);
}
